import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';

import { Component, OnInit, Input, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-test-result-category-chart',
  templateUrl: './test-result-category-chart.component.html',
  styleUrls: ['./test-result-category-chart.component.scss'],
  animations: [
    trigger('barAnimation', [
      state('init', style({ width: '0px' }), { params: { width: 0 } }),
      state('animated', style({ width: '{{width}}' }), {
        params: { width: 0 }
      }),
      transition('* => *', animate('2s 300ms ease-in-out'))
    ])
  ]
})
export class TestResultCategoryChartComponent implements OnInit, AfterViewInit {
  @Input() public testResult: any;

  public triggerAnimation = false;

  constructor() {}

  ngAfterViewInit() {
    this.triggerAnimation = true;
  }

  ngOnInit() {
    if (this.testResult) {
      this.testResult.categoryCO2e = this.testResult.categoryCO2e.slice(0, 4);
    }
  }

  getLargestCategoryCo2e(testResultParam) {
    let largestCategoryCo2e = 0;
    if (testResultParam) {
      testResultParam.categoryCO2e = testResultParam.categoryCO2e.slice(0, 4);
      largestCategoryCo2e = Math.max.apply(
        Math,
        testResultParam.categoryCO2e.map(category => {
          return category.co2e;
        })
      );
    }
    return largestCategoryCo2e;
  }

  getWidth(category) {
    const largestCategoryCo2e = this.getLargestCategoryCo2e(this.testResult);
    return Math.round((100 * category.co2e) / largestCategoryCo2e) + '%';
  }

  getRatio(category) {
    return Math.round((100 * category.co2e) / this.testResult.co2e);
  }
}
